import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { colorMap, raceDistanceMap } from './utilsMap';

const ColumnContentRight = ({ horseDetails }) => {
    const {
        raceDate,
        horseName,
        raceCourse,
        horseAge,
        horseColour1,
        horseSex,
        horseDam,
        horseDamSire,
        position,
        raceName,
        raceGrade,
        raceDistance,
    } = horseDetails;

    const getColorMap = color => (
        colorMap[color] ? colorMap[color].toLowerCase() : color.toLowerCase()
    );

    const getRaceDistanceMap = distance => (
        raceDistanceMap[distance] ? raceDistanceMap[distance] : distance
    );

    const getRaceGrade = grade => (
        isNaN(grade) ? grade : `G${grade}`
    );

    const getPositionWithPrefix = number => (
        // eslint-disable-next-line
        number + ['st', 'nd', 'rd'][((number + 90) % 100 - 10) % 10 - 1] || 'th'
    );

    const horseSexFormatted = horseSex.toLowerCase();
    const getColorFromMap = getColorMap(horseColour1);
    const getRaceDistanceFromMap = getRaceDistanceMap(raceDistance);
    const getConvertedRaceGrade = getRaceGrade(raceGrade);
    const getConvertedPosition = getPositionWithPrefix(position);

    const classContentTopLeft = classNames(
        'hp-recentStakesPerformers__container__content__row__right__content__top__left',
    );

    const classContentTopRight = classNames(
        'hp-recentStakesPerformers__container__content__row__right__content__top__right',
    );

    const classContentTopBottom = classNames(
        'hp-recentStakesPerformers__container__content__row__right__content__bottom',
    );

    return (
        <div className="hp-recentStakesPerformers__container__content__row__right__content">
            <div
                className="hp-recentStakesPerformers__container__content__row__right__content__top"
            >
                <div className={classContentTopLeft}>
                    {raceDate} {horseName}
                </div>
                <div className={classContentTopRight}>
                    {raceCourse}
                </div>
            </div>
            <div className={classContentTopBottom}>
                {`${horseAge}yo`} {getColorFromMap} {horseSexFormatted} {horseDam} {horseDamSire}
                <br />
                {getConvertedPosition} {raceName} {getConvertedRaceGrade} {getRaceDistanceFromMap}
            </div>
        </div>
    );
};

ColumnContentRight.propTypes = {
    horseDetails: PropTypes.shape({
        raceDate: PropTypes.string,
        horseName: PropTypes.string,
        raceCourse: PropTypes.string,
        horseAge: PropTypes.number,
        horseColour1: PropTypes.string,
        horseSex: PropTypes.string,
        horseDam: PropTypes.string,
        horseDamSire: PropTypes.string,
        position: PropTypes.number,
        raceName: PropTypes.string,
        raceGrade: PropTypes.string,
        raceDistance: PropTypes.string,
    }),
};


export default ColumnContentRight;



// WEBPACK FOOTER //
// ./src/js/horse/recentStakesPerformers/components/ColumnContentRight.jsx